import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint';
import gsap from "gsap";

const SEMI_TRUCK_ANIMATIONS = [
    'Semi-TruckAction', 'Semi-Truck.001Action', 'Semi-Truck.002Action',
    'Action.001', 'Green gebäude.001Action', 'tree_leaves.066Action',
    'Die ganze Stadt.001Action'
];

export default class hospital extends THREE.Object3D {
    constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
        super();

        this.initPin(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor);
    }

    initPin(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, visitedPinColor) {
        this.pinModel2 = new Heatpoint(null, "model/heatointVerticalFarm.glb");
        setTimeout(() => this.pinModel2.setColor(pinColor), 1000);
        this.pinModel2.position.set(-2.16, 0.40, 1.21);
        this.visited = false;

        interactionManager.add(this.pinModel2);

        this.pinModel2.addEventListener("click", () => this.handleClick(pinColor, pinColorDark, camera, onPinClick, gltfanimations, mixer, visitedPinColor));
        this.pinModel2.addEventListener('mouseover', () => this.handleMouseOver(pinColorDark));
        this.pinModel2.addEventListener('mouseout', () => this.handleMouseOut(pinColor, visitedPinColor));

        this.add(this.pinModel2);

        this.rotatePin();
    }

    handleClick(pinColor, pinColorDark, camera, onPinClick, gltfanimations, mixer, visitedPinColor) {
        onPinClick();
        gsap.to(camera.position, { x: -4, y: 0.8, z: 2, duration: 3, ease: "Power3.inOut" });
        this.visited = true;
        this.triggerAnimations(gltfanimations, mixer, true);
    }

    handleMouseOver(pinColorDark) {
        document.body.style.cursor = 'pointer';
        this.pinModel2.setColor(pinColorDark);
    }

    handleMouseOut(pinColor, visitedPinColor) {
        document.body.style.cursor = 'default';
        const color = this.visited ? visitedPinColor : pinColor;
        this.pinModel2.setColor(color);
    }

    getClipActionsFromNames(gltfanimations, mixer) {
        return SEMI_TRUCK_ANIMATIONS.map(name => {
            const animation = THREE.AnimationClip.findByName(gltfanimations, name);
            return mixer.clipAction(animation);
        });
    }

    triggerAnimations(gltfanimations, mixer, modal) {
        const semiTrucks = this.getClipActionsFromNames(gltfanimations, mixer);

        if (semiTrucks[0].isRunning()) {
            semiTrucks.forEach(clipAction => clipAction.stop());
        } else {
            semiTrucks.forEach(clipAction => {
                clipAction.reset();
                clipAction.timeScale = 1;
                clipAction.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            });
        }

        const modal2 = document.getElementById('modal2');
        if (modal) {
            setTimeout(() => modal2.classList.remove('hidden'), 13000);
            modal2.addEventListener('click', () => {
                modal2.classList.add('hidden');
                this.reverseAnimations(semiTrucks);
            });
        }
    }

    reverseAnimations(semiTrucks) {
        semiTrucks.forEach(clipAction => {
            clipAction.reset();
            clipAction.timeScale = -1;
            clipAction.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
        });
    }

    resetAnimations(gltfanimations, mixer) {
        const semiTrucks = this.getClipActionsFromNames(gltfanimations, mixer);

        semiTrucks.forEach(clipAction => {
            if (clipAction.time > 0) {
                clipAction.enabled = false;
            } else {
                clipAction.reset();
            }
        });
    }

    rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI,
            duration: 10,
            ease: "none",
            onUpdate: () => this.pinModel2.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle),
            repeat: -1
        });
    }
}
